import { render, staticRenderFns } from "./Toi.vue?vue&type=template&id=4be4a2a0&scoped=true"
import script from "./Toi.vue?vue&type=script&lang=js"
export * from "./Toi.vue?vue&type=script&lang=js"
import style0 from "./Toi.vue?vue&type=style&index=0&id=4be4a2a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be4a2a0",
  null
  
)

export default component.exports